// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8986f83b","455":"675dc461"}[chunkId] + ".chunk.js";
};